import React from "react";

export default function SignUp() {
  return (
    <div className="">
      <div className="">SignUp</div>
    </div>
  );
}
